import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
    return (
        <footer className='bg-gray-50 dark:bg-gray-900 border-t border-gray-700'>
            <div className='mx-auto max-w-screen-lg px-8 py-12'>
                <div className="flex flex-col md:flex-row justify-between items-center">
                    <div className="text-center md:text-left mb-4 md:mb-0">
                        <p className="text-gray-700 dark:text-gray-400 tracking-wide">
                            All rights reserved © 2025 ValuePay.ai
                        </p>
                    </div>
                    <div className="flex space-x-6">
                        <Link
                            to="/terms"
                            className="text-gray-700 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white transition-colors duration-200"
                        >
                            Terms & Conditions
                        </Link>
                        <Link
                            to="/privacy"
                            className="text-gray-700 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white transition-colors duration-200"
                        >
                            Privacy Policy
                        </Link>
                        <Link
                            to="/contact"
                            className="text-gray-700 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white transition-colors duration-200"
                        >
                            Contact
                        </Link>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
